import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import { HotelFeed } from '@bingads-webui/hotel-odata-schemas';
import messageTemplate from './column-message.pug';
import { feedErrorMapper } from './feed-error-map';

const pageContext = globalContext.require('PageContext');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');


export class FeedUploadGridOption {
  constructor({ jsdataBhc } = {}) {
    this.i18n = i18n;
    this.name = 'FeedUploadGrid';
    this.tableClasses = ['table', 'table-bordered'];
    this.dataSource = {
      type: 'js-data',
      entity: jsdataBhc.HotelFeed,
      schema: HotelFeed,
      query: { $top: 10 },
      options: {
        cacheResponse: false,
        url: '/Customers(:advertisercustomer_id)/HotelFeeds',
      },
    };
    this.columns = [
      bingadsGridColumn({
        name: 'originalFileName',
        title: this.i18n.getString('HotelCenter_FeedUpload_Grid_Filename'),
      }),
      bingadsGridColumn({
        name: 'ingenstionTime',
        title: this.i18n.getString('HotelCenter_FeedUpload_Grid_UploadTime'),
        template: local => i18n.formatDate(new Date(local.value), {
          datetime: 'full',
          timeZone: toIANATimeZone(fromLegacyTimeZone(pageContext.AccountTimeZone)),
        }),
      }),
      bingadsGridColumn({
        name: 'status',
        title: this.i18n.getString('HotelCenter_FeedUpload_Grid_Status'),
      }),
      bingadsGridColumn({
        name: 'message',
        property: item => _.pick(item, 'errors', 'matchingReportUri'),
        title: this.i18n.getString('HotelCenter_FeedUpload_Grid_Message'),
        template: local => messageTemplate({
          feedError: feedErrorMapper(local.value.errors),
          errorLink: local.value.matchingReportUri,
          linkText: i18n.getString('HotelCenter_FeedUpload_Grid_View_Detail'),
        }),
      }),
    ];
    this.plugins = {
      uiBlocker: {
        el: $('.feed-upload-grid'),
      },
    };
  }
}
